import { CustomSelectFieldProps, SelectField } from 'components/form'

export type SalaModel = {
  id: string
  label: string
}

type SalaSelectFieldProps = CustomSelectFieldProps<SalaModel> & {
  items: SalaModel[]
}

const itemToString = (item: SalaModel) => (item ? item.label : '')

export function SalaSelectField(props: SalaSelectFieldProps) {
  const { items, ...rest } = props
  return (
    <SelectField<SalaModel>
      label='Sala/Consultório para atendimento'
      placeholder='Selecione uma sala'
      itemToString={itemToString}
      items={items}
      {...rest}
    />
  )
}
